import { ITimerWorkerFactory } from "./ITimerWorkerFactory";
import TimerWorkerStub from "./TimerWorkerStub";

let timerWorkerFactory: ITimerWorkerFactory = {
    createTimerWorker() {
        return new TimerWorkerStub() as Worker;
    }
};

export function setFactory(factory: ITimerWorkerFactory) {
    timerWorkerFactory = factory;
}

export function createTimerWorker() {
    return timerWorkerFactory.createTimerWorker();
}
